import { apiRequest } from "./client";
import type { UserMe } from "../types/user";

export function login(loginValue: string, password: string): Promise<UserMe> {
  return apiRequest<UserMe>("/auth/login", {
    method: "POST",
    body: { login: loginValue, password },
  });
}

export function logout(): Promise<void> {
  return apiRequest<void>("/auth/logout", { method: "POST" });
}

export function me(signal?: AbortSignal): Promise<UserMe> {
  return apiRequest<UserMe>("/auth/me", { signal });
}

export function changePassword(
  oldPassword: string,
  newPassword: string,
): Promise<void> {
  return apiRequest<void>("/auth/change-password", {
    method: "POST",
    body: { old_password: oldPassword, new_password: newPassword },
  });
}

export function updateMyAvatar(avatarFileId: string | null): Promise<UserMe> {
  // Backend treats empty string as "clear avatar"
  return apiRequest<UserMe>("/auth/me", {
    method: "PATCH",
    body: { avatar_file_id: avatarFileId ?? "" },
  });
}
